/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect } from 'react';
import Head from 'next/head';
import CertificateDashboard from '@/components/CareerPathLearn/Certificate';
import { IcertificateDetails } from '@/components/CareerPathLearn/TypesAndInterfaces';
import { useRouter } from 'next/router';

const Certificate = () => {
  const [currentRoute, setCurrentRoute] = useState('');
  const [certificateDetails, setCertificateDetails] = useState<IcertificateDetails>();
  // get the course id for user progress api
  const router = useRouter();
  const { isCareerPath } = router.query;

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setCurrentRoute(window.location.href);
    }
  }, []);
  return (
    <>
      <Head>
        <title>{certificateDetails?.courseName} - Certificate | PW Skills</title>
        <meta
          name="title"
          content={`${certificateDetails?.courseName} - Certificate | PW Skills`}
        />
        <meta
          name="description"
          content={`Certificate of ${certificateDetails?.userDetails?.firstName} ${certificateDetails?.userDetails?.lastName} in ${certificateDetails?.courseName} - PW Skills`}
        />
        <meta name="keywords" content="PW Skills, AI, Courses, Learn, Dashboard" />

        <meta property="og:type" content="website" />
        <meta property="og:url" content={currentRoute} />
        <meta
          property="og:title"
          content={`${certificateDetails?.courseName} - Certificate | PW Skills`}
        />
        <meta
          property="og:description"
          content={`Certificate of ${certificateDetails?.userDetails?.firstName} ${certificateDetails?.userDetails?.lastName} in ${certificateDetails?.courseName} - PW Skills`}
        />

        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content={currentRoute} />
        <meta
          property="twitter:title"
          content={`${certificateDetails?.courseName} - Certificate | PW Skills`}
        />
        <meta
          property="twitter:description"
          content={`Certificate of ${certificateDetails?.userDetails?.firstName} ${certificateDetails?.userDetails?.lastName} in ${certificateDetails?.courseName} - PW Skills`}
        />
      </Head>

      <CertificateDashboard
        certificateDetails={certificateDetails}
        setCertificateDetails={
          setCertificateDetails as React.Dispatch<React.SetStateAction<IcertificateDetails>>
        }
        isCareerPath={isCareerPath === 'true'}
      />
    </>
  );
};

export default Certificate;
